import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { Button, Row, Container, Col } from "react-bootstrap";
import { StateBootstrapButton as StateButton } from '../forms/elements';
import InlineError from "../state/InlineError";
import { Counter } from "./Counter"; // JSS
// import { Link } from '@sitecore-jss/sitecore-jss-react';

var StickyCta = function StickyCta(props) {
  var _document$getElementB, _document$getElementB2;

  var cost = props.cost,
      calculatedCost = props.calculatedCost,
      addToOrderClick = props.addToOrderClick,
      modifications = props.modifications,
      errorClick = props.errorClick,
      setError = props.setError,
      counter = props.counter,
      handleCounter = props.handleCounter,
      counterValues = props.counterValues,
      errorExists = props.errorExists,
      formId = props.formId,
      _props$optionGroups = props.optionGroups,
      optionGroups = _props$optionGroups === void 0 ? [] : _props$optionGroups,
      isLoading = props.isLoading;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isDisabled = _useState4[0],
      setIsDisabled = _useState4[1];

  var StickyCtaCounterValues = _objectSpread(_objectSpread({}, counterValues), {}, {
    min: 1
  });

  var checkBoundry = function checkBoundry(top, bottom) {
    return top.getBoundingClientRect().bottom <= window.innerHeight && bottom.getBoundingClientRect().top >= window.innerHeight;
  };

  var trackScrolling = function trackScrolling() {
    var menuContainer = document.getElementById('cb-menu-detail__itemheader');
    var footer = document.getElementById('cb-footer');

    if (menuContainer && footer) {
      setActive(checkBoundry(menuContainer, footer));
    } else {
      setActive(true);
    }
  };

  var handleSelectedOptions = function handleSelectedOptions(selectedOptions) {
    if (selectedOptions && typeof selectedOptions !== undefined && selectedOptions.length) {
      return selectedOptions[0];
    }

    return null;
  };

  useEffect(function () {
    window.addEventListener("scroll", trackScrolling);
  }, []);
  useEffect(function () {
    if (formId) {
      var hasOptionGroups = Array.isArray(optionGroups) && optionGroups.length > 0;

      if (hasOptionGroups) {
        var mappedSelections = optionGroups ? optionGroups.map(function (el) {
          return el.selectedOptions[0];
        }) : [];
        var optionsNotMissing = Boolean(mappedSelections.reduce(function (el, acc) {
          return Boolean(acc) && Boolean(el);
        }, true));
        var isItemWithSides = optionGroups ? optionGroups.some(function (el) {
          return el.optionGroupName === "First Side";
        }) : false;

        if (isItemWithSides) {
          var isSideSelected = optionGroups ? optionGroups.some(function (el) {
            return el.optionGroupName === "Side 1";
          }) : false;

          if (formId.checkValidity() && optionsNotMissing && isSideSelected) {
            setIsDisabled(false);
            setError(false);
          } else {
            setIsDisabled(true);
          }
        } else {
          if (formId.checkValidity() && optionsNotMissing) {
            setIsDisabled(false);
            setError(false);
          } else {
            setIsDisabled(true);
          }
        }
      } else {
        setIsDisabled(false);
      }
    } else {
      setIsDisabled(false);
    }
  }, [formId, JSON.stringify(optionGroups)]); //Ensure array changes are picked up

  var bottom = ((_document$getElementB = document.getElementById('cb-mobile-bottom-tabs')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.style) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.height) || '0px';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: bottom
    },
    className: "\n        cb-menu-detail__sticky-bar\n        ".concat(active ? 'is-active' : '', "\n      ")
  }, /*#__PURE__*/React.createElement(Container, null, errorExists && /*#__PURE__*/React.createElement(InlineError, {
    error: {
      display: "inplace",
      body: "Please select each available customization",
      category: "food"
    },
    category: "food",
    id: "detail-customizeerror",
    errorHandler: function errorHandler() {
      errorClick();
      setError(false);
    }
  }), /*#__PURE__*/React.createElement(Row, {
    noGutters: true,
    className: "pb-2"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 5,
    lg: {
      span: 3,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Counter, {
    className: "pt-1 cb-menu-counter--lower",
    value: counter,
    setValue: handleCounter,
    counterValues: StickyCtaCounterValues
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 3,
    lg: 2
  }, (Boolean(cost) || cost !== "0.00") && /*#__PURE__*/React.createElement("div", {
    className: "mr-auto cb-menu-detail__price d-flex h-100 align-items-center justify-content-center"
  }, "$", /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: calculatedCost
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement(StateButton, {
    disabled: isDisabled,
    loading: isLoading,
    type: "submit",
    className: "cb-button-primary cb-button-primary--slim w-100",
    id: "detail-addtoorder",
    onClick: addToOrderClick
  }, /*#__PURE__*/React.createElement("div", null, "Add to order"))))));
};

export default StickyCta;